import NavigationBackHeader from '@app/components/presentational/common/NavigationBackHeader/NavigationBackHeader';
import { Box } from '@ublend-npm/aulaui-core';
import React from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'react-router-redux';
import PostDetail from './PostDetail';

interface PostDetailMobileScreenProps {
  routePostId?: string;
}

const PostDetailMobileScreen: React.FC<PostDetailMobileScreenProps> = ({
  routePostId = undefined,
}) => {
  const dispatch = useDispatch();

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        p: 2,
        pt: 1,
        gap: 1,
        flexDirection: 'column',
      }}
    >
      <NavigationBackHeader
        onClick={() => {
          dispatch(push('/home'));
        }}
      />
      <PostDetail
        params={{ postId: routePostId }}
        onClose={() => dispatch(push('/home'))}
      />
    </Box>
  );
};

export default PostDetailMobileScreen;
